module.exports = __webpack_public_path__ + "static/media/fcLogin.c15111b0.png";